export default class VersionCheckImage {
  static bindErrorEvent(imageElement) {
    imageElement.off('error').on('error', () => imageElement.hide());
  }
}



// WEBPACK FOOTER //
// ./version_check_image.js